import styled from 'styled-components';

export const ComparisonWrapper = styled.section`
  padding: 96px 0;
  background:
    radial-gradient(circle at 8% 4%, rgba(113, 151, 214, 0.16), transparent 28%),
    linear-gradient(180deg, #f7faff 0%, #ffffff 100%);

  @media (max-width: 990px) {
    padding: 72px 0;
  }

  @media (max-width: 767px) {
    padding: 56px 0;
  }
`;

export const SectionIntro = styled.div`
  max-width: 720px;
  margin: 0 auto 48px;
  text-align: center;

  > span {
    display: block;
    margin-bottom: 10px;
    color: #46679f;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  h2 {
    margin: 0 0 16px;
    color: #0f2137;
    font-size: 34px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.035em;

    span {
      white-space: nowrap;
    }
  }

  p {
    max-width: 650px;
    margin: 0 auto;
    color: #5d646d;
    font-size: 17px;
    line-height: 1.75;
  }

  @media (max-width: 767px) {
    margin-bottom: 32px;

    h2 {
      font-size: 28px;
    }

    p {
      font-size: 16px;
    }
  }
`;

export const TableShell = styled.div`
  overflow: hidden;
  border: 1px solid #dce6f2;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(44, 74, 113, 0.13);

  @media (max-width: 767px) {
    overflow: visible;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
`;

export const ComparisonTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    padding: 25px 28px;
    border-bottom: 1px solid #e4ebf3;
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    height: 128px;
    background: #fbfcfe;
  }

  thead th:first-child,
  tbody th {
    width: 22%;
  }

  thead th:not(:first-child),
  tbody td {
    width: 39%;
  }

  tbody th {
    color: #566370;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    line-height: 1.45;
    text-transform: uppercase;
  }

  tbody td {
    color: #65707c;
    font-size: 15px;
    line-height: 1.6;

    strong {
      color: #36424e;
      font-weight: 600;
    }
  }

  tr:last-child th,
  tr:last-child td {
    border-bottom: 0;
  }

  .criteria-heading {
    color: #5d6b7a;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  .cloudpouch-column {
    position: relative;
    background: linear-gradient(90deg, rgba(113, 151, 214, 0.09), rgba(113, 151, 214, 0.035));
    box-shadow: inset 3px 0 0 #7197d6;
  }

  .cloudpouch-value {
    color: #0f2137;
    font-weight: 600;
  }

  .mobile-column-label {
    display: none;
  }

  @media (max-width: 990px) {
    th,
    td {
      padding: 22px 18px;
    }

    thead th:first-child,
    tbody th {
      width: 20%;
    }

    thead th:not(:first-child),
    tbody td {
      width: 40%;
    }
  }

  @media (max-width: 767px) {
    display: block;

    thead {
      display: none;
    }

    tbody,
    tr,
    th,
    td {
      display: block;
      width: 100% !important;
    }

    tbody tr {
      overflow: hidden;
      margin-bottom: 16px;
      border: 1px solid #dce6f2;
      border-radius: 14px;
      background: #ffffff;
      box-shadow: 0 10px 30px rgba(44, 74, 113, 0.08);
    }

    tbody th {
      padding: 16px 18px;
      border-bottom: 1px solid #e4ebf3;
      background: #f7f9fc;
    }

    tbody td {
      padding: 18px;
      border-bottom: 1px solid #e4ebf3;
    }

    tbody .cloudpouch-column {
      padding-left: 21px;
      border-bottom: 0;
      background: rgba(113, 151, 214, 0.08);
      box-shadow: inset 3px 0 0 #7197d6;
    }

    .mobile-column-label {
      display: block;
      margin-bottom: 5px;
      color: #5d6672;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.08em;
      line-height: 1.4;
      text-transform: uppercase;
    }

    .cloudpouch-column .mobile-column-label {
      color: #3f629c;
    }
  }
`;

export const ProductHeading = styled.div`
  strong {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 9px;
    color: #0f2137;
    font-size: 19px;
    font-weight: 700;
    line-height: 1.35;
  }

  > span {
    color: #5d6672;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0.02em;
  }

  .cloudpouch-column & strong {
    color: #557dbd;
  }
`;

export const ProductMark = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: #46679f;
  color: #ffffff;
  font-size: 16px;
  line-height: 1;
  box-shadow: 0 6px 14px rgba(113, 151, 214, 0.28);
`;

export const TableNote = styled.div`
  margin-top: 22px;

  p {
    margin: 0;
    color: #5d6672;
    font-size: 12px;
    line-height: 1.65;
  }

  @media (max-width: 767px) {
    display: block;
    margin-top: 8px;
  }
`;

export const ComparisonCta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 38px;
  text-align: center;

  > p {
    margin: 0 0 14px;
    color: #0f2137;
    font-size: 18px;
    font-weight: 600;
  }

  .reusecore__button {
    min-width: 210px;
  }
`;
